/**
 * Created by charnjeetelectrovese@gmail.com on 2/7/2020.
 */

import React, {Component, useMemo, useState} from 'react';
import {
    MuiPickersUtilsProvider,
    KeyboardTimePicker,
    KeyboardDatePicker,
    TimePicker,
    DatePicker
} from '@material-ui/pickers';
import DateFnsUtils from "@date-io/date-fns";
import LogUtils from "../../../libs/LogUtils";
import {InputAdornment} from "@material-ui/core";
import { rest } from 'lodash';

const CustomDatePicker = ({onChange, minDate, isError, maxDate, value, label, clearable,...rest}) => {
    const [isOpen, setIsOpen] = useState(false);
    const handleOnChange = (e, d) => {
        // Manually typed dates parse to local midnight while calendar-selected
        // dates keep whatever time-of-day was already set, so the same calendar
        // day was producing two different UTC instants (and sometimes even a
        // different UTC date) once serialized. Normalizing to a fixed time here
        // keeps both entry methods in sync.
        let date = e;
        if (e instanceof Date && !isNaN(e.getTime())) {
            date = new Date(e);
            date.setHours(12, 0, 0, 0);
        }
        onChange && onChange(date);
    }

    const mD = useMemo(() => {
        const d = new Date();
        d.setFullYear(d.getFullYear() + 10);
        return maxDate ? maxDate : d;
    }, [maxDate]);

    if (clearable) {
        return (
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                    clearable
                    margin="dense"
                    variant="inline"
                    id="time-picker"
                    fullWidth
                  
                    label={label}
                    value={value ? value : (null)}
                    onChange={handleOnChange}
                    inputVariant={'outlined'}
                    format={
                        "dd-MM-yyyy"
                    }
                    error={isError ? true : false}
                    minDate={minDate}
                    maxDate={mD}
                    showTodayButton
                    // Open the calendar on a click anywhere in the field, not just the icon
                    open={isOpen}
                    onOpen={() => setIsOpen(true)}
                    onClose={() => setIsOpen(false)}
                    onClick={(e) => {
                        // Clicks inside the popover bubble here through the React portal; ignore them
                        if (e.currentTarget.contains(e.target)) setIsOpen(true);
                    }}
                    InputProps={{ readOnly: true, style: { cursor: 'pointer' } }}
                    inputProps={{ style: { cursor: 'pointer' } }}
                    {...rest}
                    // KeyboardButtonProps={{
                    //     'aria-label': 'change time',
                    // }}
                />
            </MuiPickersUtilsProvider>
        );
    }
    return (
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <DatePicker
                margin="dense"
                variant="inline"
                id="time-picker"
                fullWidth
                label={label}
                value={value ? value : (new Date())}
                onChange={handleOnChange}
                inputVariant={'outlined'}
                format={
                    "dd-MM-yyyy"
                }
                error={isError}
                minDate={minDate}
                maxDate={mD}
                // KeyboardButtonProps={{
                //     'aria-label': 'change time',
                // }}
            />
        </MuiPickersUtilsProvider>
    );
}

export default CustomDatePicker;
